{
  "version": 1,
  "asset_id": "28e3b6dc-87ae-4606-87dc-566c23383f83",
  "project_id": "3fd0b0a5-0791-4478-820e-4a65e5ab81cf",
  "url": "/__l5e/assets-v1/28e3b6dc-87ae-4606-87dc-566c23383f83/selo-marca-do-bem.png",
  "r2_key": "a/v1/3fd0b0a5-0791-4478-820e-4a65e5ab81cf/28e3b6dc-87ae-4606-87dc-566c23383f83/selo-marca-do-bem.png",
  "original_filename": "selo-marca-do-bem.png",
  "size": 282061,
  "content_type": "image/png",
  "created_at": "2026-09-25T21:47:46Z"
}
